export const bytesToMegabytes = (bytes) => {
	const value = Math.round(bytes / (1024 * 1024));
	return value || 1;
};

export const megabytesToBytes = (megabytes) => {
	return megabytes * (1024 * 1024);
};
